export default {
	INGREDIENT_ALLERGENS: 'Ingredient allergens',
};
